import { render, staticRenderFns } from "./SaleStats.vue?vue&type=template&id=65517a23"
import script from "./SaleStats.vue?vue&type=script&lang=js"
export * from "./SaleStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports